export async function buildAndDownloadApkg(
  words: { surface: string; reading: string; translation: string; exampleSentence?: string }[],
  deckName: string,
  filename: string
) {
  const initSqlJs = (await import('sql.js')).default;
  const SqlJs = await initSqlJs({
    locateFile: (f: string) => `${process.env.PUBLIC_URL || ''}/${f}`,
  });
  const db = new SqlJs.Database();
  const { Model, Deck, Package } = await import('genanki-js');
  const model = new Model({
    name: 'Japanese Vocab',
    id: String(Math.round(Date.now() / 1000)),
    flds: [
      { name: 'Expression' },
      { name: 'Reading' },
      { name: 'Meaning' },
      { name: 'Example' },
    ],
    req: [[0, 'all', [0, 1, 2]]],
    tmpls: [
      {
        name: 'Card 1',
        qfmt: '{{Expression}}',
        afmt: '{{FrontSide}}\n\n<hr id=answer>\n\n<div>{{Reading}}</div>\n<div>{{Meaning}}</div>\n{{#Example}}<br><div style="color:#888;font-size:0.85em;font-style:italic">{{Example}}</div>{{/Example}}',
      },
    ],
  });
  const deck = new Deck(Date.now() % 1e10, deckName);
  words.forEach((t) => {
    deck.addNote(
      model.note([
        t.surface,
        t.reading,
        t.translation || '',
        t.exampleSentence || '',
      ])
    );
  });
  const pkg = new Package();
  pkg.setSqlJs(db);
  pkg.addDeck(deck);
  pkg.writeToFile(filename);
}
